import Blue from '~/core'
// core version + navigation, pagination modules:
import Swiper from 'swiper'
import { Autoplay, Navigation } from 'swiper/modules'

new Blue({
  name: 'Testimonials',
  selector: '.testimonials',
  setup(testimonials) {
    const swiperEl = testimonials.querySelector('.swiper')
    new Swiper(swiperEl, {
      modules: [Autoplay, Navigation],
      direction: 'horizontal',
      loop: true,
      autoHeight: false,
      autoplay: {
        delay: 10000,
        pauseOnMouseEnter: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    })
  },
})
